/*
The given code defines a class MoreContentLoader which takes in several parameters in its constructor, including totalPages, nextUrl, buttonId, spinnerClass, containerSelector, productsSelector, and buttonContainer.

This class defines a method loadMoreContent() which uses the fetch API to retrieve the next page of content from the nextUrl URL. Once the content is retrieved, the new content is appended to the container element, and the nextUrl variable is updated with the URL for the next page of content.

The class also sets up an event listener on the button element, which triggers the loadMoreContent() method when clicked. The class also updates the buttonContainer element to display a loading spinner when loadMoreContent() is called and removes it once the content is loaded. If there is no newUrl returned from the server, the buttonContainer element is hidden.

Example implementation:
document.addEventListener('DOMContentLoaded', () => {
        var page = 1;
        var totalPages = {{ paginate.pages }};
        var nextUrl = '{{ paginate.next.url }}';



        const buttonContainer = document.querySelector("#load-more-button-container")
        {% if template contains 'blog' %}
        var container = document.querySelector('.project-cards-container');
        {% else %}
        var container = document.querySelector('#product-grid');
        {% endif %}

        const loader = new MoreContentLoader(
          totalPages,
          nextUrl,
          'load-more-button',
          'load-more_spinner',
          '{% if template contains "blog" %}.project-cards-container{% else %}#product-grid{% endif %}',
          '{% if template contains "blog" %}.project-cards-container{% else %}#product-grid{% endif %}',
          buttonContainer
        );
      });

*/
class MoreContentLoader {
  constructor(
    totalPages,
    nextUrl,
    buttonId,
    spinnerClass,
    containerSelector,
    productsSelector,
    buttonContainer
  ) {
    this.page = 1;
    this.totalPages = totalPages;
    this.nextUrl = nextUrl;
    this.button = document.getElementById(buttonId);
    this.spinner = document.querySelector(`.${spinnerClass}`);
    this.container = document.querySelector(containerSelector);
    this.productsSelector = productsSelector;
    this.buttonContainer = buttonContainer;
    this.event = new Event('more-loaded');

    this.button.addEventListener("click", () => {
      this.loadMoreContent();
    });
  }

  loadMoreContent() {
    fetch(this.nextUrl)
      .then((response) => response.text())
      .then((nextPage) => {
        let newProducts = document.createElement("div");
        newProducts.innerHTML = nextPage;
        newProducts.querySelector(`${this.productsSelector} > *`).dataset.newlyLoaded = '';
        newProducts = newProducts.querySelector(this.productsSelector);
        let newUrl = newProducts.dataset.nextUrl;

        this.container.querySelector('[data-newly-loaded]')?.removeAttribute('data-newly-loaded');

        this.buttonContainer.classList.remove("loading");
        this.container.insertAdjacentHTML("beforeend", newProducts.innerHTML);

        if (newUrl) {
          // this.button.style.display = "inline-block";
          this.buttonContainer.classList.remove("loading");
          this.nextUrl = newUrl;
        } else {
          // this.button.style.display = "none";
          document.querySelector('.pagination-wrapper').style.display = "none";
        }

        window.dispatchEvent(this.event);
        this.container.querySelector('[data-newly-loaded]').scrollIntoView({ block: "center"});
      })
      .catch((error) => {
        console.error("An error occurred while making the request.", error);
      });

    // this.button.style.display = "none";
    this.buttonContainer.classList.add("loading");
  }
}
